import * as API from "@/services/API";

export default {
    async getSchoolsFreeTrial(page = 1, perPage = 10) {
        try {
            const response = await API.apiClient.get('/admin-dashboard/schools-free-trial', {
                params: { page, per_page: perPage }
            })
            return response.data
        } catch (error) {
            throw error
        }
    },

    async setSchoolFreeTrial(schoolId, freeTrial) {
        try {
            const response = await API.apiClient.post('/admin-dashboard/set-school-free-trial', {
                school_id: schoolId,
                free_trial: freeTrial
            })
            return response.data
        } catch (error) {
            throw error
        }
    }
}
